import React, { useContext, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { Card, Grid, Button, ButtonGroup, Hidden, Avatar } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import FilterListIcon from '@material-ui/icons/FilterList';
import FlagIcon from '@material-ui/icons/Flag';
import { useHistory } from 'react-router-dom';
import '../../../Core/Dashbord/mainDashboard.scss';
import { GetTechnitianDashHeaderRecords } from '../../../Core/Service/technician-service';
import { GetInternalDashTechnicianJobs, GetInternalDashReturn, GetInternalDashPartReq } from '../../../Core/Service/dashbordService';
import TechnicianDashboardCharts from './TechnicianDashboardCharts';
import FilterModalMainTabComponent from '../../../Components/internal/dashboard/FilterModalMainTabComp';
import DialogComp from '../../../Core/Modal/dialogModal';
import AppContext from '../../../App/AppContext';
import { useWindowSize } from '../../../Core/Controls/ScreenResolution';
import { AppStorage } from '../../../Core/Service/storage-service';

function scrollbarVisible(element) {
    if (!element) return false;
    return element.scrollWidth > element.clientWidth;
}

let config = {
    wipNumber: {
        from: 'displayWIPNo',
        to: 'userGridColumnDisplayWIPNo',
        getSequence: 'wipNoSequence',
        postSequence: 'WIPNoSequence'
    },
    registration: {
        from: 'displayVehicleReg',
        to: 'userGridColumnDisplayVehicleReg',
        getSequence: 'vehicleRegSequence',
        postSequence: 'VehicleRegSequence'
    },
    makeModel: {
        from: 'displayModel',
        to: 'userGridColumnDisplayModel',
        getSequence: 'modelSequence',
        postSequence: 'modelSequence'
    },
    customerName: {
        from: 'displayCustomer',
        to: 'userGridColumnDisplayCustomer',
        getSequence: 'customerSequence',
        postSequence: 'customerSequence'
    },
    dateDueIn: {
        from: 'displayDateDueIn',
        to: 'userGridColumnDisplayDateDueIn',
        getSequence: 'dateDueInSequence',
        postSequence: 'dateDueInSequence'
    },
    dateDueOut: {
        from: 'displayDateDueOut',
        to: 'userGridColumnDisplayDateDueOut',
        getSequence: 'dateDueOutSequence',
        postSequence: 'dateDueOutSequence'
    },
    returnReason: {
        from: 'displayReturnReason',
        to: 'userGridColumnDisplayReturnReason',
        getSequence: 'returnReasonSequence',
        postSequence: 'returnReasonSequence'
    },
    branchShortName: {
        from: 'displayBranch',
        to: 'userGridColumnDisplayBranch',
        getSequence: 'branchSequence',
        postSequence: 'branchSequence'
    },
    franchiseName: {
        from: 'displayFranchise',
        to: 'userGridColumnDisplayFranchise',
        getSequence: 'franchiseSequence',
        postSequence: 'franchiseSequence'
    },
    st: {
        from: 'displayJobDescription',
        to: 'userGridColumnDisplayJobDescription',
        getSequence: 'jobDescriptionSequence',
        postSequence: 'jobDescriptionSequence'
    },
    accountNo: {
        from: 'displayAccount',
        to: 'userGridColumnDisplayAccount',
        getSequence: 'accountSequence',
        postSequence: 'accountSequence'
    },
    cb: {
        from: 'displayCreatedBy',
        to: 'userGridColumnDisplayCreatedBy',
        getSequence: 'createdBySequence',
        postSequence: 'createdBySequence'
    },
    assigned: {
        from: 'displayAssignedDate',
        to: 'userGridColumnDisplayAssignedDate',
        getSequence: 'assignedDateSequence',
        postSequence: 'assignedDateSequence'
    },
    taken: {
        from: 'displayTimeTaken',
        to: 'userGridColumnDisplayTimeTaken',
        getSequence: 'timeTakenSequence',
        postSequence: 'timeTakenSequence'
    },
    status: {
        from: 'displayStatus',
        to: 'UserGridColumnDisplayStatus',
        getSequence: 'statusSequence',
        postSequence: 'statusSequence'
    },
    assignedDays: {
        from: 'displayAssignedDays',
        to: 'UserGridColumnDisplayAssignedDays',
        getSequence: 'assignedDaysSequence',
        postSequence: 'assignedDaysSequence'
    },
    owningOperator: {
        from: 'displayOwningOperator',
        to: 'UserGridDisplayColumnOwningOperator',
        getSequence: 'owningOperatorSequence',
        postSequence: 'owningOperatorSequence'
    },
    jobAssignedUser: {
        from: 'displayJobAssignedUser',
        to: 'UserGridColumnDisplayJobAssignedUser',
        getSequence: 'jobAssignedUserSequence',
        postSequence: 'jobAssignedUserSequence'
    },
    chassisNumber: {
        from: 'displayChassisNumber',
        to: 'UserGridColumnDisplayChassisNumber',
        getSequence: 'chassisNumberSequence',
        postSequence: 'chassisNumberSequence'
    },
    courtesyCarReq: {
        from: 'displayCourtesyCarReq',
        to: 'UserGridColumnDisplayCourtesyCarReq',
        getSequence: 'courtesyCarReqSequence',
        postSequence: 'courtesyCarReqSequence'
    },
    customerWaiting: {
        from: 'displayCustomerWaiting',
        to: 'UserGridColumnDisplayCustomerWaiting',
        getSequence: 'customerWaitingSequence',
        postSequence: 'customerWaitingSequence'
    },
    wipAge: {
        from: 'displayWIPAge',
        to: 'UserGridColumnDisplayWIPAge',
        getSequence: 'wipAgeSequence',
        postSequence: 'wipAgeSequence'
    },
    isFMOrWarranty: {
        from: 'displayIsFMOrWarranty',
        to: 'UserGridColumnDisplayIsFMOrWarranty',
        getSequence: 'isFMOrWarrantySequence',
        postSequence: 'isFMOrWarrantySequence'
    },
    isBreakdown: {
        from: 'displayIsBreakdown',
        to: 'UserGridColumnDisplayIsBreakdown',
        getSequence: 'isBreakdownSequence',
        postSequence: 'isBreakdownSequence'
    },
    isNightShift: {
        from: 'displayIsNightShift',
        to: 'UserGridColumnDisplayIsNightShift',
        getSequence: 'isNightShiftSequence',
        postSequence: 'isNightShiftSequence'
    },
    isHighPriority: {
        from: 'displayIsHighPriority',
        to: 'UserGridColumnDisplayIsHighPriority',
        getSequence: 'isHighPrioritySequence',
        postSequence: 'isHighPrioritySequence'
    }
};

const isFalseValue = (val) => {
    if (val == false) {
        return false;
    } else {
        return true;
    }
};

const FilterButton = ({ isActive, onClick, label }) => {
    return (
        <Button
            style={{
                fontSize: 10,
                color: isActive ? 'green' : 'black'
            }}
            onClick={onClick}
        >
            {isActive ? <CheckCircleIcon style={{ color: 'green', fontSize: 13 }} /> : null}
            &nbsp; {label}
        </Button>
    );
};

function getUniqueList(arr, key) {
    const uniqueValues = new Set();
    return arr.filter((item) => {
        const isDuplicate = uniqueValues.has(item[key]);
        uniqueValues.add(item[key]);
        return !isDuplicate;
    });
}

const computeWorkflowData = (allRecords, branch) => {
    if (!allRecords || allRecords.length === 0) {
        return {
            headerRecord: [],
            workflowData: [],
            sumOfAllWorkflows: 0
        };
    }

    const isAll = !branch || branch === 'Default' || branch === 'All Branches';
    const filtered = isAll
        ? allRecords
        : allRecords.filter(
              (item) =>
                  String(item.bn || '')
                      .toLowerCase()
                      .trim() === String(branch).toLowerCase().trim()
          );

    const headerWorkflowData = filtered.reduce((acc, obj) => {
        const index = acc.find((item) => item.workflow === obj.workflow);
        index ? (index.total += obj.total || 0) : acc.push({ ...obj, total: obj.total || 0 });
        return acc;
    }, []);

    const workflowData = headerWorkflowData.map((m) => ({
        name: m.workflow,
        value: m.total,
        workflowID: m.workflowID
    }));

    let sumOfAllWorkflows = 0;
    workflowData.forEach((item) => {
        sumOfAllWorkflows += item.value || 0;
    });

    return {
        headerRecord: headerWorkflowData,
        workflowData: workflowData,
        sumOfAllWorkflows: sumOfAllWorkflows
    };
};

const hexToRgba = (hex, alpha = 1) => {
    if (!hex) return `rgba(24, 59, 104, ${alpha})`;
    let c = hex.replace('#', '');
    if (c.length === 3) {
        c = c
            .split('')
            .map((x) => x + x)
            .join('');
    }
    const num = parseInt(c, 16);
    if (isNaN(num)) return `rgba(24, 59, 104, ${alpha})`;
    const r = (num >> 16) & 255;
    const g = (num >> 8) & 255;
    const b = num & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const TechnicianDashboardContent = (props) => {
    const workflowRef = useRef(null);
    const history = useHistory();
    const { portalSettings, getUserPreference, isAppReaload } = useContext(AppContext);
    const [WindowWidths, WindowHeights] = useWindowSize();

    const headerBg = portalSettings?.portalHeaderBackgroundColour || '#183b68';
    const headerText = portalSettings?.portalHeaderTextColour || '#ffffff';
    const lightHeaderBg = hexToRgba(headerBg, 0.06);
    const lightHeaderBorder = hexToRgba(headerBg, 0.16);
    const lightBadgeBg = hexToRgba(headerBg, 0.12);

    const scrollNext = () => {
        workflowRef.current?.scrollBy({ left: 100, top: 0, behavior: 'smooth' });
    };

    const scrollPrev = () => {
        workflowRef.current?.scrollBy({ left: -100, top: 0, behavior: 'smooth' });
    };

    const isTacrdAllowed = AppStorage.getCanAccessTCard();

    const [state, setState] = useState({
        isShowScrollArrow: false,
        allHeaderRecords: [],
        workflowData: [],
        chartdata: [],
        headerRecord: [],
        assignedUserList: [],
        assignedJobs: [],
        btnID: 'home',
        total: '',
        sumOfAllWorkflows: 0,
        sumOFByTimeForALL: [],
        showHeaderLoader: true,
        tcardCount: 0,
        partReqList: [],
        returnList: [],
        selectedBranch: JSON.parse(localStorage.getItem('FiltterParams'))?.branchShortName || 'Default',
        technicianJobsData: [],
        scheduleEvents: [],
        inspectionCount: [],
        showTechnicianLoader: true,
        showFilter: false,
        showFlag: false,
        filterList: [],
        appbarLocation: 'T',
        languageCode: '',
        languageData: [],
        tempObj: {},
        displayPagination: true,
        hideWorkflowScrollbar: false,
        userGridColumnTCardNoOfDays: null,
        showJobHeader: {}
    });

    const [parts, setParts] = useState({
        partReqList: [],
        returnList: []
    });

    let getBtnParams = JSON.parse(localStorage.getItem('FiltterParams')) || {};

    const [grpBtn, setGrpBtn] = useState({
        priority: getBtnParams?.isHighPriority === 'yes',
        FM: getBtnParams?.isFMOrWarranty === 'yes',
        Night: getBtnParams?.isNightShift === 'yes',
        Breakdown: getBtnParams?.isBreakdown === 'yes'
    });

    const handleButtonFlag = (name) => {
        setGrpBtn((prevState) => {
            const updatedState = {
                ...prevState,
                [name]: !prevState[name]
            };
            const updatedParams = { ...getBtnParams };
            if (name === 'priority') {
                updatedParams.isHighPriority = updatedState.priority ? 'yes' : '';
            } else if (name === 'FM') {
                updatedParams.isFMOrWarranty = updatedState.FM ? 'yes' : '';
            } else if (name === 'Breakdown') {
                updatedParams.isBreakdown = updatedState.Breakdown ? 'yes' : '';
            } else if (name === 'Night') {
                updatedParams.isNightShift = updatedState.Night ? 'yes' : '';
            }
            localStorage.setItem('FiltterParams', JSON.stringify(updatedParams));
            return updatedState;
        });
    };

    const pullPartReq = async () => {
        try {
            const [partReqRes, returnRes] = await Promise.all([
                GetInternalDashPartReq(props.processID, grpBtn.priority, grpBtn.FM, grpBtn.Night, grpBtn.Breakdown),
                GetInternalDashReturn(props.processID, grpBtn.priority, grpBtn.FM, grpBtn.Night, grpBtn.Breakdown)
            ]);

            if (partReqRes?.success && returnRes?.success) {
                const formattedPartReqList = (partReqRes.data?.list || []).map((item) => ({
                    ...item,
                    BarColor: `6px solid ${item.bgColor}`
                }));

                const formattedReturnList = (returnRes.data?.list || []).map((item) => ({
                    ...item,
                    BarColor: `6px solid ${item.bgColor}`
                }));

                setState((prevState) => ({
                    ...prevState,
                    partReqList: formattedPartReqList,
                    returnList: formattedReturnList
                }));
            }
        } catch (error) {
            console.error('Error fetching parts/return data:', error);
        }
    };

    const getPartReq = (branchId) => {
        let partReqList = [...state.partReqList];
        let returnList = [...state.returnList];

        if (branchId === 'Default') {
            const allPartReq = partReqList.reduce((acc, obj) => {
                const index = acc.find((item) => item.label === obj.label);
                index ? (index.value += obj.value) : acc.push({ ...obj });
                return acc;
            }, []);
            const allpartReqturn = returnList.reduce((acc, obj) => {
                const index = acc.find((item) => item.label === obj.label);
                index ? (index.value += obj.value) : acc.push({ ...obj });
                return acc;
            }, []);
            setParts({
                partReqList: allPartReq,
                returnList: allpartReqturn
            });
        } else {
            let newPartReqList = partReqList
                .map((cond) => ({
                    ...cond,
                    value: cond.bn === branchId ? cond.value : 0,
                    BarColor: cond.BarColor,
                    bn: branchId
                }))
                .reduce((acc, obj) => {
                    const index = acc.find((item) => item.label === obj.label);
                    index ? (index.value += obj.value) : acc.push({ ...obj });
                    return acc;
                }, []);

            let newReturnList = returnList
                .map((cond) => ({
                    ...cond,
                    value: cond.bn === branchId ? cond.value : 0,
                    BarColor: cond.BarColor,
                    bn: branchId
                }))
                .reduce((acc, obj) => {
                    const index = acc.find((item) => item.label === obj.label);
                    index ? (index.value += obj.value) : acc.push({ ...obj });
                    return acc;
                }, []);

            setParts({
                partReqList: newPartReqList,
                returnList: newReturnList
            });
        }
    };

    useEffect(() => {
        getPartReq(state.selectedBranch);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.partReqList, state.returnList]);

    const GetHeaderRecords = async () => {
        try {
            let GetHeaderRecordsFromAPI = await GetTechnitianDashHeaderRecords(props.processID, grpBtn.priority, grpBtn.FM, grpBtn.Night, grpBtn.Breakdown);

            let resPayload = GetHeaderRecordsFromAPI;
            if (GetHeaderRecordsFromAPI && GetHeaderRecordsFromAPI.data !== undefined) {
                resPayload = GetHeaderRecordsFromAPI.data;
            }

            let rawHeaderList = [];
            let assignedJobs = [];
            let tcardCount = 0;

            if (Array.isArray(resPayload)) {
                rawHeaderList = resPayload;
            } else if (resPayload && typeof resPayload === 'object') {
                rawHeaderList =
                    resPayload.headerRecord ||
                    resPayload.HeaderRecord ||
                    resPayload.technitianDashHeaderRecords ||
                    resPayload.TechnitianDashHeaderRecords ||
                    resPayload.technicianDashHeaderRecords ||
                    resPayload.TechnicianDashHeaderRecords ||
                    resPayload.dashHeaderRecords ||
                    resPayload.DashHeaderRecords ||
                    resPayload.list ||
                    resPayload.List ||
                    resPayload.records ||
                    resPayload.Records ||
                    [];

                if (!rawHeaderList.length) {
                    const arrKey = Object.keys(resPayload).find(
                        (k) =>
                            Array.isArray(resPayload[k]) &&
                            !['userPreferenceWorkflows', 'UserPreferenceWorkflows', 'assignedUser', 'AssignedUser', 'tCardCount', 'TCardCount'].includes(k)
                    );
                    if (arrKey) {
                        rawHeaderList = resPayload[arrKey];
                    }
                }

                assignedJobs = resPayload.assignedUser || resPayload.AssignedUser || [];
                // tCardCount can come back as a number, an object { column1 } or an
                // array of one such object. Always resolve to a number so it is never
                // rendered as an object (React: "Objects are not valid as a React child").
                const rawTcard = resPayload.tCardCount ?? resPayload.TCardCount;
                const pickCount = (v) =>
                    v && typeof v === 'object' ? v.breakdownCount ?? v.BreakdownCount ?? v.column1 ?? v.Column1 ?? 0 : v;
                tcardCount = Number(pickCount(Array.isArray(rawTcard) ? rawTcard[0] : rawTcard)) || 0;
            }

            let headerRecord = (rawHeaderList || []).map((item) => ({
                ...item,
                workflow: item.workflow || item.Workflow,
                workflowID: item.workflowID !== undefined ? item.workflowID : item.WorkflowID,
                total: item.total !== undefined ? item.total : item.Total !== undefined ? item.Total : 0,
                bn: item.bn || item.Bn || item.BranchShortName || item.branchShortName || '',
                lessThan24HoursOld: item.lessThan24HoursOld !== undefined ? item.lessThan24HoursOld : item.LessThan24HoursOld || 0,
                between1And5DaysOld: item.between1And5DaysOld !== undefined ? item.between1And5DaysOld : item.Between1And5DaysOld || 0,
                between5And10DaysOld: item.between5And10DaysOld !== undefined ? item.between5And10DaysOld : item.Between5And10DaysOld || 0,
                between10And20DaysOld: item.between10And20DaysOld !== undefined ? item.between10And20DaysOld : item.Between10And20DaysOld || 0,
                between21And30DaysOld: item.between21And30DaysOld !== undefined ? item.between21And30DaysOld : item.Between21And30DaysOld || 0,
                over30DaysOld: item.over30DaysOld !== undefined ? item.over30DaysOld : item.Over30DaysOld || 0,
                preBooking: item.preBooking !== undefined ? item.preBooking : item.PreBooking || 0,
                between1to10Days: item.between1to10Days !== undefined ? item.between1to10Days : item.Between1to10Days || 0,
                between11And20Days: item.between11And20Days !== undefined ? item.between11And20Days : item.Between11And20Days || 0,
                between21And30Days: item.between21And30Days !== undefined ? item.between21And30Days : item.Between21And30Days || 0,
                overdueOver30DaysOld: item.overdueOver30DaysOld !== undefined ? item.overdueOver30DaysOld : item.OverdueOver30DaysOld || 0,
                overdueArchived: item.overdueArchived !== undefined ? item.overdueArchived : item.OverdueArchived || 0
            }));

            let assignedUserList = [];
            if (assignedJobs.length > 0) {
                assignedUserList = getUniqueList(assignedJobs, 'userID');
            }

            if (headerRecord.length > 0) {
                const branchArr = headerRecord.reduce((acc, obj) => {
                    const index = acc.find((item) => item.bn === obj.bn);
                    index ? (index.total += obj.total) : acc.push({ ...obj });
                    return acc;
                }, []);

                let chartdata = branchArr.map((m) => ({
                    name: m.bn,
                    value: m.total
                }));

                const sumOFByTimeForALL = headerRecord.reduce((acc, obj) => {
                    var index = acc.find((item) => item.bn === obj?.bn);
                    if (index) {
                        index.lessThan24HoursOld += obj?.lessThan24HoursOld || 0;
                        index.between1And5DaysOld += obj?.between1And5DaysOld || 0;
                        index.between5And10DaysOld += obj?.between5And10DaysOld || 0;
                        index.between10And20DaysOld += obj?.between10And20DaysOld || 0;
                        index.between21And30DaysOld += obj?.between21And30DaysOld || 0;
                        index.over30DaysOld += obj?.over30DaysOld || 0;
                        index.preBooking += obj?.preBooking || 0;
                        index.between1to10Days += obj?.between1to10Days || 0;
                        index.between11And20Days += obj?.between11And20Days || 0;
                        index.between21And30Days += obj?.between21And30Days || 0;
                        index.overdueOver30DaysOld += obj?.overdueOver30DaysOld || 0;
                        index.overdueArchived += obj?.overdueArchived || 0;
                        return acc;
                    }
                    acc.push({ ...obj });
                    return acc;
                }, []);

                const currentBranch = state.selectedBranch || JSON.parse(localStorage.getItem('FiltterParams'))?.branchShortName || 'Default';
                const { headerRecord: computedHeaderRecord, workflowData, sumOfAllWorkflows } = computeWorkflowData(headerRecord, currentBranch);

                setState((st) => ({
                    ...st,
                    allHeaderRecords: headerRecord,
                    assignedUserList: assignedUserList,
                    assignedJobs: assignedJobs,
                    workflowData: workflowData,
                    chartdata: chartdata,
                    headerRecord: computedHeaderRecord,
                    sumOfAllWorkflows: sumOfAllWorkflows,
                    sumOFByTimeForALL: sumOFByTimeForALL,
                    showHeaderLoader: false,
                    tcardCount: tcardCount || 0
                }));
            } else {
                setState((st) => ({
                    ...st,
                    allHeaderRecords: [],
                    assignedUserList: assignedUserList,
                    assignedJobs: assignedJobs,
                    workflowData: [],
                    chartdata: [],
                    headerRecord: [],
                    sumOfAllWorkflows: 0,
                    sumOFByTimeForALL: [],
                    showHeaderLoader: false,
                    tcardCount: tcardCount || 0
                }));
            }
        } catch (err) {
            console.error('Error in GetHeaderRecords:', err);
            setState((st) => ({
                ...st,
                showHeaderLoader: false
            }));
        }
    };

    const GetTechnicianData = async () => {
        try {
            let response = await GetInternalDashTechnicianJobs(props.processID, grpBtn.priority, grpBtn.FM, grpBtn.Night, grpBtn.Breakdown);
            if (response?.success) {
                let technicianJobs = response?.data?.technicianJobs ? [...response.data.technicianJobs] : [];
                let newResult = [];
                if (technicianJobs.length > 0) {
                    let result = technicianJobs.map((m) => {
                        let newObj = technicianJobs.filter((n) => n.bn === m.bn);
                        newObj.bn = m.bn;
                        return newObj;
                    });
                    newResult = Object.values(result.reduce((acc, cur) => Object.assign(acc, { [cur.bn]: cur }), {}));
                }

                setState((st) => ({
                    ...st,
                    technicianJobsData: newResult,
                    scheduleEvents: response?.data?.scheduleEvents || [],
                    inspectionCount: response?.data?.inspectionCount || [],
                    showTechnicianLoader: false
                }));
            } else {
                setState((st) => ({
                    ...st,
                    showTechnicianLoader: false
                }));
            }
        } catch (err) {
            console.error('Error fetching technician jobs:', err);
            setState((st) => ({
                ...st,
                showTechnicianLoader: false
            }));
        }
    };

    useEffect(() => {
        GetHeaderRecords();
        GetTechnicianData();
        pullPartReq();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [grpBtn, props.processID]);

    const getbranchByOnchange = (branchName) => {
        const { headerRecord: computedHeaderRecord, workflowData, sumOfAllWorkflows } = computeWorkflowData(state.allHeaderRecords || [], branchName);
        setState((st) => ({
            ...st,
            selectedBranch: branchName,
            headerRecord: computedHeaderRecord,
            workflowData: workflowData,
            sumOfAllWorkflows: sumOfAllWorkflows
        }));
    };

    const buttonClicked = (btn) => {
        let tempData = JSON.parse(localStorage.getItem('FiltterParams')) || {};
        localStorage.setItem('FiltterParams', JSON.stringify({ ...tempData, branchShortName: tempData.branchShortName }));
        localStorage.setItem('currentWorkflowId', btn?.workflowID || 'All');

        const btnName = (btn?.workflow || btn?.name || '').toLowerCase().trim();
        const isAssignedToYou = btnName.includes('assigned to you') || btn?.workflowID === 1 || btn?.id === 1;
        const isAssignedToOthers = btnName.includes('assigned to others') || btn?.workflowID === 3 || btn?.id === 3;

        let bucketId = null;
        let workflowName = btn?.workflow || btn?.name || '';

        if (isAssignedToOthers) {
            bucketId = 3;
        } else if (isAssignedToYou) {
            bucketId = 1;
        } else if (btn?.workflowID && btn?.workflowID !== 'All') {
            bucketId = btn.workflowID;
        } else if (btn?.id && btn?.id !== 'All') {
            bucketId = btn.id;
        }

        history.push({
            pathname: '/technicianApp',
            search: bucketId ? `?bucketId=${bucketId}&name=${encodeURIComponent(workflowName)}` : `?name=${encodeURIComponent(workflowName)}`,
            state: { bucketId: bucketId, workflowName: workflowName, workflowID: btn?.workflowID }
        });
    };

    const pullGridFilterList = async () => {
        let data = getUserPreference ? getUserPreference() : null;
        if (data && data.details && data.details[0]) {
            setState((st) => ({
                ...st,
                appbarLocation: data.details[0].appbarLocation || 'T',
                languageCode: data.details[0].languageCode,
                languageData: data.languages,
                tempObj: data.details[0] || {},
                displayPagination: isFalseValue(data.details[0]?.displayPagination),
                hideWorkflowScrollbar: isFalseValue(data.details[0]?.hideWorkflowScrollbar),
                userGridColumnTCardNoOfDays: data.details[0]?.userGridColumnTCardNoOfDays,
                showJobHeader: {
                    showHeaderWIPNumber: data?.details[0]?.showHeaderWIPNumber || false,
                    showHeaderRegNumber: data?.details[0]?.showHeaderRegNumber || false,
                    showHeaderCustomer: data?.details[0]?.showHeaderCustomer || false,
                    showHeaderKeyNumber: data?.details[0]?.showHeaderKeyNumber || false,
                    showHeaderChassisNumber: data?.details[0]?.showHeaderChassisNumber || false,
                    showHeaderOutstandingPayment: data?.details[0]?.showHeaderOutstandingPayment || false,
                    showHeaderCreditLimit: data?.details[0]?.showHeaderCreditLimit || false,
                    showHeaderWorkDetails: data?.details[0]?.showHeaderWorkDetails || false,
                    showHeaderCashMessage: data?.details[0]?.showHeaderCashMessage || false,
                    showHeaderCustomerOrderNo: data?.details[0]?.showHeaderCustomerOrderNo || false
                }
            }));
        }
    };

    useEffect(() => {
        pullGridFilterList();
    }, [isAppReaload]);

    const baseColumns = [
        { field: 'wipNumber', sortable: true, title: `${portalSettings?.portalSettingGridWIPNoLabel || 'WIP No'}`, width: 70 },
        { field: 'registration', sortable: true, title: `${portalSettings?.portalSettingGridVehicleRegLabel || 'Vehicle Reg'}`, width: 90 },
        { field: 'makeModel', sortable: true, title: `${portalSettings?.portalSettingGridModelLabel || 'Model'}`, width: 200 },
        { field: 'customerName', sortable: true, title: `${portalSettings?.portalSettingGridCustomerNameLabel || 'Customer Name'}`, width: 200 },
        {
            field: 'dateDueIn',
            sortable: true,
            title: `${portalSettings?.portalSettingGridDateDueInLabel || 'Date Due In'}`,
            type: 'dateTime',
            width: 135
        },
        {
            field: 'dateDueOut',
            sortable: true,
            title: `${portalSettings?.portalSettingGridDateDueOutLabel || 'Date Due Out'}`,
            type: 'dateTime',
            width: 135
        },
        { field: 'returnReason', sortable: true, title: `${portalSettings?.portalSettingGridReturnReasonLabel || 'Return Reason'}`, width: 190 },
        { field: 'chassisNumber', sortable: true, title: 'Chassis Number', width: 180 },
        { field: 'branchShortName', sortable: true, title: `${portalSettings?.portalSettingGridBranchLabel || 'Branch'}`, width: 120 },
        { field: 'franchiseName', sortable: true, title: `${portalSettings?.portalSettingGridFranchiseLabel || 'Franchise'}`, width: 160 },
        { field: 'accountNo', sortable: true, title: `${portalSettings?.portalSettingGridAccountLabel || 'Account'}`, width: 80 },
        { field: 'st', sortable: true, title: `${portalSettings?.portalSettingGridJobDescriptionLabel || 'Job Description'}`, width: 170 },
        { field: 'cb', sortable: true, title: `${portalSettings?.portalSettingGridCreatedByLabel || 'Created By'}`, width: 100 },
        {
            field: 'assigned',
            sortable: true,
            title: `${portalSettings?.portalSettingGridAssignedDateLabel || 'Assigned Date'}`,
            width: 120
        },
        {
            field: 'taken',
            sortable: true,
            title: `${portalSettings?.portalSettingGridTimeTakenLabel || 'Time Taken'}`,
            width: 90
        },
        {
            field: 'status',
            sortable: true,
            title: `${portalSettings?.portalSettingGridStatusLabel || 'Status'}`,
            width: 100
        },
        {
            field: 'assignedDays',
            sortable: true,
            title: `${portalSettings?.portalSettingGridAssignedDaysLabel || 'Assigned Days'}`,
            width: 100
        },
        {
            field: 'owningOperator',
            sortable: true,
            title: `${portalSettings?.portalSettingGridOwningOperatorLabel || 'Owning Operator'}`,
            width: 100
        },
        {
            field: 'jobAssignedUser',
            sortable: true,
            title: `${portalSettings?.portalSettingGridJobAssignedUserLabel || 'Job Assigned User'}`,
            width: 100
        },
        {
            field: 'courtesyCarReq',
            sortable: true,
            title: `${portalSettings?.portalSettingGridCourtesyCarReqLabel || 'Courtesy Car Req'}`,
            width: 80
        },
        {
            field: 'customerWaiting',
            sortable: true,
            title: `${portalSettings?.portalSettingGridCustomerWaitingLabel || 'Customer Waiting'}`,
            width: 80
        },
        {
            field: 'wipAge',
            sortable: true,
            title: `${portalSettings?.portalSettingGridWIPAgeLabel || 'WIP Age'}`,
            width: 80
        },
        {
            field: 'isFMOrWarranty',
            sortable: true,
            title: `${portalSettings?.portalSettingGridIsFMOrWarrantyLabel || 'Is FM Or Warranty'}`,
            width: 80
        },
        {
            field: 'isBreakdown',
            sortable: true,
            title: `${portalSettings?.portalSettingGridIsBreakdownLabel || 'Is Breakdown'}`,
            width: 80
        },
        {
            field: 'isNightShift',
            sortable: true,
            title: `${portalSettings?.portalSettingGridIsNightShiftLabel || 'Is Night Shift'}`,
            width: 80
        },
        {
            field: 'isHighPriority',
            sortable: true,
            title: `${portalSettings?.portalSettingGridIsHighPriorityLabel || 'Is High Priority'}`,
            width: 80
        }
    ];

    const handleOpen = () => {
        let tempArr = [...baseColumns]
            .map((q) => {
                return {
                    field: q.field,
                    title: q.title,
                    hidden: !q.hidden,
                    fieldName: config[q.field]?.to,
                    postSequenceFieldName: config[q.field]?.postSequence
                };
            })
            .filter((p) => p.title !== 'Action');

        setState((st) => ({ ...st, showFilter: true, filterList: tempArr }));
    };

    const handleFlagOpen = () => {
        setState((st) => ({ ...st, showFlag: true }));
    };

    const closeDialog = (res) => {
        setState((st) => ({ ...st, showFilter: false }));
        if (res) {
            pullGridFilterList();
            GetHeaderRecords();
        }
    };

    useEffect(() => {
        try {
            if (workflowRef.current) {
                const isVisible = scrollbarVisible(workflowRef.current);
                setState((st) => ({
                    ...st,
                    isShowScrollArrow: isVisible
                }));
            }
        } catch (error) {
            console.error('Error checking scroll arrow visibility:', error);
        }
    }, [WindowWidths, state.headerRecord, state.hideWorkflowScrollbar]);

    const [headerEl, setHeaderEl] = useState(() => document.getElementById('technician-header-actions') || document.getElementById('dashboard-header-actions'));

    useEffect(() => {
        if (!headerEl) {
            const el = document.getElementById('technician-header-actions') || document.getElementById('dashboard-header-actions');
            if (el) setHeaderEl(el);
        }
    }, [headerEl]);

    const handleTopBranchChange = (e) => {
        const val = e.target.value;
        let currentFilterParams = JSON.parse(localStorage.getItem('FiltterParams')) || {};
        localStorage.setItem(
            'FiltterParams',
            JSON.stringify({
                ...currentFilterParams,
                branchShortName: val !== 'Default' ? val : ''
            })
        );
        let currentDashboard = JSON.parse(localStorage.getItem('_dashboard_')) || {};
        if (val !== 'Default') {
            localStorage.setItem(
                '_dashboard_',
                JSON.stringify({
                    ...currentDashboard,
                    BranchBytime: val,
                    selectedValueByTech: val,
                    BranchPartReq: val
                })
            );
        } else {
            localStorage.setItem(
                '_dashboard_',
                JSON.stringify({
                    ...currentDashboard,
                    selectedValueByTech: 'Default',
                    BranchPartReq: 'Default'
                })
            );
        }

        const { headerRecord: computedHeaderRecord, workflowData, sumOfAllWorkflows } = computeWorkflowData(state.allHeaderRecords || [], val);

        setState((st) => ({
            ...st,
            selectedBranch: val,
            headerRecord: computedHeaderRecord,
            workflowData: workflowData,
            sumOfAllWorkflows: sumOfAllWorkflows
        }));

        getPartReq(val);
    };

    const filterButtonsContent = (
        <div className="technician-dash-topbar" style={{ marginBottom: 0, padding: 0 }}>
            <div className="filter-chips-wrapper">
                <select value={state.selectedBranch || 'Default'} onChange={handleTopBranchChange} className="branch-select-topbar">
                    <option value="Default">All Branches</option>
                    {(state.chartdata || []).map((b, i) => (
                        <option key={i} value={b.name}>
                            {b.name}
                        </option>
                    ))}
                </select>
                <Hidden only={['sm', 'xs']}>
                    {isTacrdAllowed && (
                        <button type="button" className="filter-chip-btn breakdown-chip" onClick={() => history.push('/tCards_List?isBreakdown=true')}>
                            <span>Breakdowns</span>
                            <span className="filter-chip-badge">{state.tcardCount || 0}</span>
                        </button>
                    )}
                    <button type="button" className={`filter-chip-btn ${grpBtn.priority ? 'active' : ''}`} onClick={() => handleButtonFlag('priority')}>
                        {grpBtn.priority && <CheckCircleIcon className="filter-chip-icon" />}
                        <span>Cash Job</span>
                    </button>
                    <button type="button" className={`filter-chip-btn ${grpBtn.FM ? 'active' : ''}`} onClick={() => handleButtonFlag('FM')}>
                        {grpBtn.FM && <CheckCircleIcon className="filter-chip-icon" />}
                        <span>Is FM Or Warranty Job</span>
                    </button>
                    <button type="button" className={`filter-chip-btn ${grpBtn.Breakdown ? 'active' : ''}`} onClick={() => handleButtonFlag('Breakdown')}>
                        {grpBtn.Breakdown && <CheckCircleIcon className="filter-chip-icon" />}
                        <span>Is Breakdown Job</span>
                    </button>
                    <button type="button" className={`filter-chip-btn ${grpBtn.Night ? 'active' : ''}`} onClick={() => handleButtonFlag('Night')}>
                        {grpBtn.Night && <CheckCircleIcon className="filter-chip-icon" />}
                        <span>Is Night Shift Job</span>
                    </button>
                </Hidden>
            </div>
        </div>
    );

    return (
        <div>
            {headerEl && ReactDOM.createPortal(filterButtonsContent, headerEl)}
            <div style={{ padding: '8px 12px', background: '#f8fafc', minHeight: '100%', boxSizing: 'border-box' }} className="mainDashboard-container">
                <Avatar className="avatar-filter-btn" onClick={handleOpen} title="My Preferences">
                    <FilterListIcon />
                </Avatar>

                {!headerEl && filterButtonsContent}
                <Hidden only={['md', 'lg', 'xl']}>
                    <Avatar className="avatar-filter-btn-flags" onClick={handleFlagOpen}>
                        <FlagIcon />
                    </Avatar>
                </Hidden>

                {state.showFlag && (
                    <DialogComp title="" onClose={() => setState((st) => ({ ...st, showFlag: false }))} maxWidth="md">
                        <ButtonGroup aria-label="outlined primary button group" color="primary" style={{}}>
                            {/* <Badge color="secondary" badgeContent={state.tcardCount} className="tcard-badge"> */}
                            {isTacrdAllowed && (
                                <FilterButton
                                    isActive={grpBtn.priority}
                                    onClick={() => history.push('/tCards_List?isBreakdown=true')}
                                    label={`Breakdowns-(${state.tcardCount})`}
                                />
                            )}
                            {/* </Badge> */}
                            <FilterButton isActive={grpBtn.priority} onClick={() => handleButtonFlag('priority')} label="High Priority" />
                            <FilterButton isActive={grpBtn.FM} onClick={() => handleButtonFlag('FM')} label="Is FM Or Warranty Job" />
                        </ButtonGroup>
                        <ButtonGroup aria-label="outlined primary button group" color="primary" style={{}}>
                            <FilterButton isActive={grpBtn.Breakdown} onClick={() => handleButtonFlag('Breakdown')} label="Is Breakdown Job" />
                            <FilterButton isActive={grpBtn.Night} onClick={() => handleButtonFlag('Night')} label="Is Night Shift Job" />
                        </ButtonGroup>
                    </DialogComp>
                )}

                {/* Workflow Status Cards Carousel */}
                {!state.hideWorkflowScrollbar ? (
                    <div className="workflow-main-container" style={{ marginBottom: 10 }}>
                        {state.isShowScrollArrow && (
                            <span onClick={scrollPrev} className="ScrollArrow-Container" title="Scroll Left">
                                <ChevronLeftIcon fontSize="small" />
                            </span>
                        )}

                        <div style={{ overflow: 'auto', display: 'flex', width: '100%', alignItems: 'center' }} className="btn-container" ref={workflowRef}>
                            {Array.isArray(state.headerRecord) &&
                                state.headerRecord.map((m, i) => {
                                    if (m?.workflow !== 'Archived') {
                                        return (
                                            <div className="workflow-container-padding" key={m?.workflowID || i}>
                                                <Card
                                                    className={`workflow-card-design ${state.btnID === m?.workflowID ? 'workflow-card-design-isActive' : ''}`}
                                                    style={
                                                        state.btnID === m?.workflowID
                                                            ? {
                                                                  backgroundColor: headerBg,
                                                                  borderColor: headerBg,
                                                                  color: headerText
                                                              }
                                                            : {
                                                                  backgroundColor: lightHeaderBg,
                                                                  borderColor: lightHeaderBorder
                                                              }
                                                    }
                                                    onClick={() => buttonClicked(m)}
                                                >
                                                    <div className="workflow-labels">
                                                        <span style={state.btnID === m?.workflowID ? { color: headerText } : {}}>{m?.workflow}</span>
                                                        <div style={state.btnID === m?.workflowID ? { color: headerText } : {}}>{m?.total}</div>
                                                    </div>
                                                </Card>
                                            </div>
                                        );
                                    }
                                    return null;
                                })}

                            <div className="workflow-container-padding">
                                <Card
                                    className={`workflow-card-design ${state.total === 'total' ? 'workflow-card-design-isActive' : ''}`}
                                    style={
                                        state.total === 'total'
                                            ? {
                                                  backgroundColor: headerBg,
                                                  borderColor: headerBg,
                                                  color: headerText
                                              }
                                            : {
                                                  backgroundColor: lightHeaderBg,
                                                  borderColor: lightHeaderBorder
                                              }
                                    }
                                    onClick={() => buttonClicked({ workflowID: 'All' })}
                                >
                                    <div className="workflow-labels">
                                        <span style={state.total === 'total' ? { color: headerText } : {}}>Total</span>
                                        <div style={state.total === 'total' ? { color: headerText } : {}}>{state.sumOfAllWorkflows}</div>
                                    </div>
                                </Card>
                            </div>
                        </div>

                        {state.isShowScrollArrow && (
                            <span onClick={scrollNext} className="ScrollArrow-Container" title="Scroll Right">
                                <ChevronRightIcon fontSize="small" />
                            </span>
                        )}
                    </div>
                ) : (
                    <div className="workflow-compact-container">
                        {Array.isArray(state.headerRecord) &&
                            state.headerRecord.map((m, i) => {
                                if (m?.workflow !== 'Archived') {
                                    const isActive = state.btnID === m?.workflowID;
                                    return (
                                        <button
                                            type="button"
                                            key={m?.workflowID || i}
                                            className={`workflow-compact-btn ${isActive ? 'active' : ''}`}
                                            style={
                                                isActive
                                                    ? {
                                                          backgroundColor: headerBg,
                                                          borderColor: headerBg,
                                                          color: headerText
                                                      }
                                                    : {
                                                          backgroundColor: lightHeaderBg,
                                                          borderColor: lightHeaderBorder
                                                      }
                                            }
                                            onClick={() => buttonClicked(m)}
                                        >
                                            <span className="workflow-compact-name" style={isActive ? { color: headerText } : {}}>
                                                {m?.workflow}
                                            </span>
                                            <span
                                                className="workflow-compact-count"
                                                style={
                                                    isActive
                                                        ? {
                                                              backgroundColor: 'rgba(255, 255, 255, 0.25)',
                                                              color: headerText
                                                          }
                                                        : {
                                                              backgroundColor: lightBadgeBg,
                                                              color: '#091e42'
                                                          }
                                                }
                                            >
                                                {m?.total}
                                            </span>
                                        </button>
                                    );
                                }
                                return null;
                            })}

                        <button
                            type="button"
                            className={`workflow-compact-btn ${state.total === 'total' ? 'active' : ''}`}
                            style={
                                state.total === 'total'
                                    ? {
                                          backgroundColor: headerBg,
                                          borderColor: headerBg,
                                          color: headerText
                                      }
                                    : {
                                          backgroundColor: lightHeaderBg,
                                          borderColor: lightHeaderBorder
                                      }
                            }
                            onClick={() => buttonClicked({ workflowID: 'All' })}
                        >
                            <span className="workflow-compact-name" style={state.total === 'total' ? { color: headerText } : {}}>
                                Total
                            </span>
                            <span
                                className="workflow-compact-count"
                                style={
                                    state.total === 'total'
                                        ? {
                                              backgroundColor: 'rgba(255, 255, 255, 0.25)',
                                              color: headerText
                                          }
                                        : {
                                              backgroundColor: lightBadgeBg,
                                              color: '#091e42'
                                          }
                                }
                            >
                                {state.sumOfAllWorkflows}
                            </span>
                        </button>
                    </div>
                )}

                {/* Charts and Summary Section */}
                <div style={{ width: '100%' }}>
                    <TechnicianDashboardCharts
                        state={state}
                        processID={props.processID}
                        onChartClickHandler={buttonClicked}
                        getbranchByOnchange={getbranchByOnchange}
                        parts={parts}
                        getPartReq={getPartReq}
                        selectedBranch={state.selectedBranch}
                    />
                </div>
            </div>

            {state.showFilter ? (
                <DialogComp title="My Preferences" maxWidth="md" fullWidth onClose={() => closeDialog(false)} overflow="auto">
                    <FilterModalMainTabComponent
                        languageCode={state.languageCode}
                        appbarLocation={state.appbarLocation}
                        filterConfig={config}
                        filterList={state.filterList}
                        handleCancel={closeDialog}
                        languageData={state.languageData}
                        isPagination={state.displayPagination}
                        ishideWorkflowScrollbar={state.hideWorkflowScrollbar}
                        tcardDays={state.userGridColumnTCardNoOfDays}
                        showJobHeader={state.showJobHeader}
                    />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default TechnicianDashboardContent;
